import {DceJsx, DceJsxRenderer} from "dce-jsx";
import {Editor} from "@tiptap/core";
import {Transaction, NodeSelection} from "prosemirror-state";
import ICONS from "../../assets/ICONS";
import {OpenDialog} from "dce-components";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {ToolbarItem} from "../ToolbarItem";

export interface ImageItemProps {
    dialogUrl:string;
}

export class ImageItem extends ToolbarItem {

    private editor: Editor;

    private props: ImageItemProps;

    private openDialogInitialized: boolean = false;

    constructor(props: ImageItemProps) {
        super();
        this.props = props;
    }

    public mount(editor: Editor): void {
        this.editor = editor;
    }

    public consumeTransaction(editor: Editor, transaction: Transaction): void{

        console.log("Image Item transaction");

        let tsel = transaction.selection;

        if(tsel instanceof NodeSelection){

            let sel = tsel as NodeSelection;

            console.log("Node selection", sel);

            if(sel.node.type.name == 'image'){
                console.log("SELECTED IMAGE!");

                let start = editor.view.coordsAtPos(transaction.selection.from)
                let end = editor.view.coordsAtPos(transaction.selection.to);

                console.log('selected dom', editor.view.nodeDOM(transaction.selection.from));

                console.log("START", start, transaction.selection.from);
                console.log("END", end, transaction.selection.to);
                console.log("S", end, editor.view.domAtPos(transaction.selection.from));
                console.log("E", end, editor.view.domAtPos(transaction.selection.to));

            }

        }

    }

    public click(e: any){
        (e as MouseEvent).preventDefault();

        if(!this.openDialogInitialized) {
            let openDialog = new OpenDialog(this.root as DceHTMLElement, {
                url: this.props.dialogUrl,
                target: "#main",
                bindClick: true,
            });

            openDialog.addOnClose((d, e) => {

                let saved = d.getFormSaved();

                if (saved) {
                    let data = d.getFormResponse();

                    let src = null;
                    if (data.data.hasOwnProperty('src')) {
                        src = data.data.src;
                    }

                    if (null != src) {

                        this.editor.chain().focus()
                            .setImage({src: src, inline: false})
                            .run()

                    }
                }
            });

            openDialog.loadDialog();
            this.openDialogInitialized = true;
        }

    }

    render(): JSX.Element {
        return (
            <button type="button" onClick={(e) => this.click(e)} dangerouslySetInnerHTML={ {__html: ICONS.image} }></button>
        )
    }

}

